import React, { lazy, Suspense, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from 'react-router';
import NotFound from './pages/Lost/404.jsx';
import { Provider, useDispatch } from 'react-redux';
import { store } from 'store';
import {
  ProtectedRoute,
  createAuthMiddleware,
} from 'api/middleware/authMiddleware';
import { authService } from 'api/services/auth';
import Loading from 'pages/Loading/Loading';
import { Navbar, ToastProvider } from 'components';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './App.scss';

const Login = lazy(() => import('./pages/Login/Login'));
const Admin = lazy(() => import('./pages/Admin/Admin'));
const Signup = lazy(() => import('./pages/Signup/Signup'));
const Build = lazy(() => import('./pages/Build/Build'));
const Prompts = lazy(() => import('./pages/Prompts/Prompts'));
const Contracts = lazy(() => import('./pages/Contracts/Contracts'));
const Landing = lazy(() => import('./pages/Landing/Landing.jsx'));
const Profile = lazy(() => import('./pages/Profile/Profile'));

function AppRoutes() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(true);
  const authMiddleware = createAuthMiddleware(store);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const isAuthenticated = await authService.checkAuth(dispatch);
        if (!isAuthenticated) {
          // navigate('/');
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, [navigate, dispatch]);

  useEffect(() => {
    const originalOnUnauthorized = authMiddleware.onUnauthorized;
    authMiddleware.onUnauthorized = () => originalOnUnauthorized(navigate);
  }, [navigate, authMiddleware]);

  useEffect(() => {
    const originalOnError = authMiddleware.onError;
    authMiddleware.onError = (error) => originalOnError(error);
  }, [authMiddleware]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ToastProvider>
      <div className='App'>
        <Navbar title='GIGACORE' />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path='/' element={<Landing />} />
            <Route path='/login' element={<Login />} />
            <Route path='/loading' element={<Loading />} />
            <Route path='/signup/:hash?' element={<Signup />} />
            <Route
              path='/build/*'
              element={
                <ProtectedRoute>
                  <Build />
                </ProtectedRoute>
              }
            />
            <Route
              path='/prompts/*'
              element={
                <ProtectedRoute>
                  <Prompts />
                </ProtectedRoute>
              }
            />
            <Route
              path='/contracts/*'
              element={
                <ProtectedRoute>
                  <Contracts />
                </ProtectedRoute>
              }
            />
            <Route
              path='/profile'
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path='/profile/:userId'
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path='/admin'
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </ToastProvider>
  );
}

// Main App component
function App() {
  return (
    <GoogleOAuthProvider clientId="290584307863-0bu8jcn05e5btogetrihegaoch8182vs.apps.googleusercontent.com">
      <Provider store={store}>
        <Router>
          <AppRoutes />
        </Router>
      </Provider>
    </GoogleOAuthProvider>
  );
}

export default App;
